import { useOutletContext, useParams } from "react-router-dom";

import Unauthorized from "../../ui/components/Unauthorized/Unauthorized";

import useHasRight from "../../authorization/hooks/useHasRight";

import PriceView from "../views/PriceView/PriceView";

export default function Price() {
	const { id } = useParams();
	const hasRight = useHasRight();
	const { organization } = useOutletContext();

	if (!hasRight("prices.view")) {
		return <Unauthorized />;
	}

	return <PriceView id={id} organization={organization} />;
}
